import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "moment__inner" }
const _hoisted_2 = {
  key: 0,
  class: "moment__image"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "moment__no-image-container"
}
const _hoisted_5 = {
  key: 1,
  class: "moment__image-placeholder"
}
const _hoisted_6 = { class: "moment__content-area" }
const _hoisted_7 = { class: "moment__text-area" }
const _hoisted_8 = { class: "moment__category-year-wrapper" }
const _hoisted_9 = {
  key: 0,
  class: "moment__category"
}
const _hoisted_10 = {
  key: 1,
  class: "moment__category-placeholder"
}
const _hoisted_11 = { class: "moment__year" }
const _hoisted_12 = { class: "moment__text-wrapper" }
const _hoisted_13 = { class: "moment__title" }
const _hoisted_14 = { class: "moment__excerpt" }

import { computed, ref } from "vue";
import { useTimelineMapStore } from "@features/Pages/TimelineMapPage/_js/app/store/timelineMapStore";
import type { ITimelineMapItem } from "../../interfaces/ITimelineMapItem";


export default /*@__PURE__*/_defineComponent({
  __name: 'MomentMM',
  props: {
    moment: {},
    index: {},
    animateIn: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const store = useTimelineMapStore();

const root = ref<HTMLElement | null>(null);
__expose({ root });

const isMoment = computed(() => props.moment.type === "Moment");
const animateIn = computed(() => props.animateIn ?? false);
const animationDelay = computed(() => `${(props.index ?? 0) * 100}ms`);

function onClick() {
  if (isMoment.value) {
    store.onShowModal(props.moment);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    ref_key: "root",
    ref: root,
    class: _normalizeClass(["moment", {
      'moment--is-type-moment': isMoment.value,
      'reveal-animate': animateIn.value
    }]),
    style: _normalizeStyle({ animationDelay: animationDelay.value }),
    key: __props.moment.urlSegment,
    onClick: onClick,
    onKeydown: [
      _withKeys(onClick, ["enter"]),
      _withKeys(onClick, ["space"])
    ],
    tabindex: "0"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (isMoment.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (__props.moment.imageHtml)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "moment__media",
                  innerHTML: __props.moment.imageHtml
                }, null, 8 /* PROPS */, _hoisted_3))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("span", { class: "moment__no-image-graphic" }, null, -1 /* CACHED */)
                ]))]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (__props.moment.category)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(__props.moment.category), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("span", _hoisted_10)),
            _createElementVNode("span", _hoisted_11, _toDisplayString(__props.moment.year), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h4", _hoisted_13, _toDisplayString(__props.moment.title), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_14, _toDisplayString(__props.moment.momentExcerpt), 1 /* TEXT */)
          ])
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "moment__arrow" }, null, -1 /* CACHED */))
      ])
    ])
  ], 38 /* CLASS, STYLE, NEED_HYDRATION */))
}
}

})